import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';
import {
  TipoReporte,
  Reporte,
  ReporteTramite,
  ReportesCategoria,
} from '@app/shared';

@Injectable()
export class ReportsDataService {
  constructor(private http: HttpClient, private toastr: ToastrService, private api: EndpointService) {}

  /**
   * Consulta de todos los reportes
   *
   * @returns {Observable<Reporte[]>}
   * @memberof ReportsDataService
   */
  getReports(): Observable<Reporte[]> {
    return new Observable(obs => {
      this.http.get<Reporte[]>(this.api.get('adminReports')).subscribe(
        reports => {
          if (reports && reports.length) {
            reports.sort((a, b) => a.id - b.id);
          }
          obs.next(reports);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Consulta de los tipos de reportes
   *
   * @returns {Observable<TipoReporte[]>}
   * @memberof ReportsDataService
   */
  getTypesReports(): Observable<TipoReporte[]> {
    return new Observable(obs => {
      this.http.get<TipoReporte[]>(this.api.get('typeReports')).subscribe(
        types => {
          if (types && types.length) {
            types.sort((a, b) => a.id - b.id);
          }
          obs.next(types);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Agrega un reporte al sistema
   *
   * @param {Reporte} data
   * @returns {Observable<boolean>}
   * @memberof ReportsDataService
   */
  addReport(data: FormData): Observable<boolean> {
    return new Observable(obs => {
      this.http.post<boolean>(this.api.get('adminReports'), data).subscribe(
        report => {
          this.toastr.success('Reporte creado con éxito', 'Operación exitosa');
          obs.next(true);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Actualiza un reporte
   *
   * @param {Reporte} data
   * @param {number} idReport
   * @returns {Observable<boolean>}
   * @memberof ReportsDataService
   */
  updateReport(data: FormData, idReport: number): Observable<boolean> {
    return new Observable(obs => {
      this.http.put<boolean>(this.api.get('adminReports', [idReport]), data).subscribe(
        report => {
          this.toastr.success('Reporte actualizado con éxito', 'Operación exitosa');
          obs.next(true);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Elimina un reporte
   *
   * @param {number} idReport
   * @returns {Observable<boolean>}
   * @memberof ReportsDataService
   */
  deleteReport(idReport: number): Observable<boolean> {
    return new Observable(obs => {
      this.http.delete<boolean>(this.api.get('adminReports', [idReport])).subscribe(
        report => {
          this.toastr.success('Reporte eliminado con éxito', 'Operación exitosa');
          obs.next(true);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Consulta de los tramites asociados a el reporte
   *
   * @param {number} idReport
   * @returns {Observable<ReporteTramite[]>}
   * @memberof ReportsDataService
   */
  getReportsTramites(idReport: number): Observable<ReporteTramite[]> {
    return new Observable(obs => {
      this.http.get<ReporteTramite[]>(this.api.get('reportTramites', [idReport])).subscribe(
        reports => {
          if (reports && reports.length) {
            reports.sort((a, b) => a.id - b.id);
          }
          obs.next(reports);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Consulta de los reportes por categoria
   *
   * @param {number} idCategory
   * @returns {Observable<Reporte[]>}
   * @memberof ReportsDataService
   */
  getReportsCategory(idCategory: number): Observable<ReportesCategoria> {
    return new Observable(obs => {
      this.http.get<ReportesCategoria>(this.api.get('categoryReports', [idCategory])).subscribe(
        category => {
          if (category && category.reportes && category.reportes.length) {
            category.reportes.sort((a, b) => a.id - b.id);
          }
          obs.next(category);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/management-reports/reports/shared/reports.data.service.ts